import root from 'state/window';

export const getInitialState = () => ({
	x: 0,
	y: 0,
	zoom: 1.02,
	width: root.innerWidth,
	height: root.innerHeight
});

const setZoom = (state, scale) => {
	const { x, y, zoom, width, height } = state;
	const nextZoom = zoom * scale;
	if (nextZoom > 6 || nextZoom < 1.01) {
		return state;
	}
	return {
		...state,
		x: x * scale + (1 - scale) * width / 2,
		y: y * scale + (1 - scale) * height / 2,
		zoom: nextZoom
	};
};

const setCenter = (state, x, y) => ({
	...state,
	x: Math.max(
		Math.min(x, 0),
		state.zoom === 1 ? 0 : -state.width * (state.zoom - 0.8)
	),
	y: Math.max(
		Math.min(y, 0),
		state.zoom === 1 ? 0 : -state.height * (state.zoom - 1)
	)
});

const focusOn = (state, x, y) =>
	setCenter(
		state,
		-(x * state.zoom - state.width / 2),
		-(y * state.zoom - state.height / 2)
	);

const reset = getInitialState;
const zoomIn = state => setZoom(state, 1.5);
const zoomOut = state => setZoom(state, 0.5);
const resize = (state, width = root.innerWidth, height = root.innerHeight) => ({
	...state,
	width,
	height
});

export const actions = { setCenter, focusOn, reset, zoomIn, zoomOut, resize };

export default {
	getInitialState,
	actions
};



// WEBPACK FOOTER //
// ./state/map.js